import React, { useState, useEffect } from 'react';
import { Icon, Input } from '@iq/react-components';

const SiteFilter = ({ onChange }) => {
  const [filter, setFilter] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => onChange(filter), 650);
    return () => clearTimeout(timer);
  }, [filter]);

  const updateValue = ({ target: { value } }) => {
    // Statement added because tests do not handle timeouts well
    if (process.env.NODE_ENV === 'test') {
      onChange(value);
    }
    setFilter(value);
  };

  const resetValue = () => {
    setFilter('');
    onChange('');
  };

  return (
    <div className="site-filter-component">
      <Input
        value={filter}
        placeholder="Filter projects..."
        onChange={updateValue}
      />
      <Icon
        size="xs"
        icon="he-close"
        onClick={resetValue}
      />
    </div>
  );
};

export default SiteFilter;
